import { ExistingFirmResponse } from 'api/firm/firm.types';
import {
  ApiSubmissionFunnelType,
  mapApiSubmissionFunnelTypeToForm,
} from 'pages/ApplicationFormPage/Submission/submissionRouteHelpers';
import { SubmissionFunnelTypeEnum } from 'pages/ApplicationFormPage/Submission/types';
import { getBtlSubmissionRouteUIConfig, isValidBtlFunnelTypeForFirm } from './btlSubmissionRouteConfig';

export function resolveBtlInitialFunnelType(
  firm: ExistingFirmResponse,
  savedFunnelType: SubmissionFunnelTypeEnum | '' | undefined,
): SubmissionFunnelTypeEnum {
  const config = getBtlSubmissionRouteUIConfig(firm);

  if (savedFunnelType && isValidBtlFunnelTypeForFirm(firm, savedFunnelType)) {
    return savedFunnelType;
  }

  return config.defaultOption;
}

export function resolveBtlInitialFunnelTypeFromApi(
  firm: ExistingFirmResponse,
  savedApiFunnelType: ApiSubmissionFunnelType | undefined,
): SubmissionFunnelTypeEnum {
  return resolveBtlInitialFunnelType(firm, mapApiSubmissionFunnelTypeToForm(savedApiFunnelType));
}
